<template>
    <div class="max_box" ref="maxBox">
        <!-- 模型属性 -->
        <div class="div_tab" v-show="isQcType"><div class="div_title_span">生效技能组<span style="color: #F56C6C;font-weight: bold;"> * </span></div></div>
        <div class="div_box" v-show="isQcType">
            <el-select
                    v-model="input_data.userList"
                    class="div_input"
                    multiple
                    collapse-tags
                    size="small"
                    clearable
                    :disabled="IsEdit && (!$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430') || !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101431'))"
                    placeholder="请选择技能组">
                <el-option :label="item.text" :value="item.value" v-for="(item, index) in customerGroup" :key="index"></el-option>
            </el-select>
        </div>
        <!-- 模型属性 -->
        <div class="div_tab"><div class="div_title_span">模型位置<span style="color: #F56C6C;font-weight: bold;"> * </span></div></div>
        <div class="div_box">
            <el-select
                    @change="input_data.attr_pos_value = 0"
                    v-model="input_data.attr_pos"
                    class="div_input"
                    size="small"
                    clearable
                    placeholder="请选择模型位置">
                <el-option label="任意" :value="0" ></el-option>
                <el-option label="会话初" :value="1" ></el-option>
            </el-select>
            <el-input-number v-if="input_data.attr_pos === 1" v-model="input_data.attr_pos_value" style="width: 100px;margin: 0 10px;" :precision="0" size="small" controls-position="right" :min="0" :max="99999999"></el-input-number>
            <span v-if="input_data.attr_pos === 1" style="font-size: 14px;color: #555">句内</span>
        </div>
        <!-- 模型属性 -->
        <div class="div_tab" v-show="!isQcType"><div class="div_title_span">模型属性</div></div>
        <div class="div_box" v-show="!isQcType">
            <span class="div_span">所属角色</span>
            <el-select class="div_input" v-model="input_data.role" placeholder="请选择所属角色" size="small" clearable>
                <el-option label="客户" :value="1"></el-option>
                <el-option label="坐席" :value="2"></el-option>
                <el-option label="客户or坐席" :value="0"></el-option>
            </el-select>
        </div>
        <!-- 添加规则 -->
        <div class="div_tab" v-show="(IsEdit && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430')) || !IsEdit"><div class="div_title_span">添加规则</div></div>
        <div class="div_box" v-show="(IsEdit && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430')) || !IsEdit">
            <div class="div_main_header">
                <!--<el-input v-model="input" placeholder="请输入内容" plain size="mini" style="width: 150px;" @keyup.enter.native="add()" :disabled="edit_but.open">
                    <i slot="suffix" class="el-input__icon el-icon-plus"></i>
                </el-input>-->
                <el-select
                        v-model="input"
                        filterable
                        remote
                        placeholder="请输入关键词"
                        :remote-method="remoteMethod"
                        :loading="selectLoad"
                        plain size="mini"
                        style="width: 170px;margin-right: 10px;"
                        :disabled="edit_but.open"
                        @change="add()"
                        icon="el-icon-search"
                >
                    <el-option
                            v-for="(item, index) in selectItem"
                            :key="index"
                            :label="item"
                            :value="item">
                    </el-option>
                </el-select>

                <el-button class="div_main_header_button" type="primary" plain size="mini" @click="or_but()" :disabled="edit_but.open">或</el-button>
                <el-button class="div_main_header_button" type="success" plain size="mini" @click="notEssential()" :disabled="edit_but.open">可有可无</el-button>
                <el-button class="div_main_header_button" type="danger" plain size="mini" @click="notButton()" :disabled="edit_but.open">非</el-button>
                <el-button class="div_main_header_button" type="warning" plain size="mini" @click="order_but()" :disabled="edit_but.open">有序</el-button>
                <el-popover
                        placement="bottom-start"
                        width="400"
                        trigger="hover"
                        popper-class="el-popover-qc"
                >
                    <div style="width: auto;font-size: 12px;color: #777;line-height: 20px">
                        <span style="font-weight: bold">自定义添加规则</span><br/>
                        <span>每个词或词组需要加'{}' 例如：{A}</span><br/>
                    </div>
                    <i class="el-icon-warning-outline div_title_span_i" style="margin-top: 5px" slot="reference" v-show="edit_but.open"></i>
                </el-popover>
                <el-button class="div_main_header_button_right" type="danger" size="mini" @click="delSpanButton()" :disabled="edit_but.open"><i class="el-icon-delete"></i></el-button>
                <el-button class="div_main_header_button_right" size="mini" v-show="edit_but.open"  @click="closeEdit()"><i class="el-icon-edit"></i></el-button>
                <el-button class="div_main_header_button_right" type="info" size="mini" v-show="!edit_but.open" @click="openEdit()"><i class="el-icon-edit"></i></el-button>
                <el-button class="div_main_header_button_right" size="mini" :disabled="edit_but.open || upbut.length == 0"  @click="upbutTo()"><i class="el-icon-d-arrow-right"></i></el-button>
                <el-button class="div_main_header_button_right" size="mini" :disabled="edit_but.open || downbut.length == 0"  @click="downbutTo()"><i class="el-icon-d-arrow-left"></i></el-button>
            </div>
            <!-- 视图窗口 -->
            <div class="div_main_body" v-show="!edit_but.open">
                <div :class="highlight(item)" v-for="(item,index) in input_data.type_item" :key="index" @click="selectSpan(item)">
                    <span v-for="(items,index) in item.zn_data" :key="index" :class="span_col(item.id,items.type)">{{items.text}}</span>
                </div>
            </div>
            <!-- 编辑窗口 -->
            <div class="div_main_body_edit" v-show="edit_but.open">
                <el-input
                        type="textarea"
                        :rows="5"
                        style="resize:none;"
                        v-model="edit_but.text">
                </el-input>
            </div>
            <!-- 测试使用(不要删) -->
            <!--<div>错误队列：<span v-for="(item, index) in errorItems" :key="index">,&nbsp;&nbsp;&nbsp;&nbsp;{{item}}</span></div>
            <div>错误选中：<span v-for="(item, index) in errorItemsActivity" :key="index">,&nbsp;&nbsp;&nbsp;&nbsp;{{item}}</span></div>
            <div>一般队列：<span v-for="(item, index) in input_data.type_item" :key="index">,&nbsp;&nbsp;&nbsp;&nbsp;{{item.id}}</span></div>
            <div>一般选中：<span v-for="(item, index) in activity" :key="index">,&nbsp;&nbsp;&nbsp;&nbsp;{{item.id}}</span></div>-->
            <div class="div_main_foot">
                <el-button  size="mini" @click="clearAllbut()" :disabled="edit_but.open">清空</el-button>
                <el-button  type="primary" size="mini" @click="addAll()" :disabled="edit_but.open" style="margin-left: 15px;">确定</el-button>
            </div>
        </div>
        <!-- 模型规则 -->
        <div class="div_tab">
            <div class="div_title_span">
                <span>模型规则<span style="color: #F56C6C;font-weight: bold;"> * </span></span>
                <el-popover
                        placement="bottom-start"
                        width="400"
                        trigger="hover"
                        popper-class="el-popover-qc"
                >
                    <div style="width: auto;font-size: 12px;color: #777;line-height: 20px">
                        <span style="font-weight: bold">基本标签规则</span><br/>
                        <span> 1.或：多个关键词之间或的关系，如：A|B</span><br/>
                        <span>2.可有可无：关键词可有可无，如：A?</span><br/>
                        <span>3.有序：关键词之间的先后关系，如：A~B</span><br/>
                        <span>4.非：对整个关键词标签生效，不管是复合标签还是简单标签，如：!A</span><br/>
                        <span style="font-weight: bold">复合标签规则</span><br/>
                        <span>1.添加关系时，若选中标签含有复合标签，则自动在复合标签中添加小括号，再与其他标签进行整合</span><br/>
                        <span>2.选中复合标签后不可点选 或，可有可无</span><br/>
                        <span>3.一个标签中只能有一个可有可无的关键词</span><br/>
                        <span>4.可有可无的关键词与其他关键词存在或关系时，置于这几个词的末尾</span><br/>
                    </div>
                    <i class="el-icon-warning-outline div_title_span_i" slot="reference"></i>
                </el-popover>
            </div>
        </div>
        <div class="div_box">
            <div class="end_box">
                <div class="end_box_item" v-for="(items,index) in allItem" :key="index">
                    <div class="end_box_xu">{{index + 1}}</div>
                    <div class="end_box_text">
                        <div class="end_box_text_div" v-for="(item,indexs) in arrayAllItem(items)" :key="indexs"><span class="end_box_text_span">{{item}}</span></div>
                    </div>
                    <div class="end_box_edit" @click="editItem(items.id)" v-if="(IsEdit && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430')) || !IsEdit"><i class="el-icon-edit"></i></div>
                    <div class="end_box_remove" @click="delallItem(items.id)" v-if="(IsEdit && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430')) || !IsEdit"><i class="el-icon-delete-solid"></i></div>
                </div>
            </div>
        </div>
        <!-- 保存按钮 -->
        <div class="div_box" style="text-align: center;">
            <el-checkbox v-model="input_data.release" style="margin-right: 30px;" v-if="(!IsEdit && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '101310')) ||  (IsEdit && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '101432'))">发布</el-checkbox>
            <el-button size="small" style="margin-right: 0px;width: 62px" @click="cancel()">取消</el-button>
            <!-- 添加保存 -->
            <el-button type="primary" size="small" style="margin-right: 5px;width: 62px" @click="addModels()" v-if="!IsEdit">
                <span v-show="!save_load">保存</span>
                <span v-show="save_load"><i class="el-icon-loading"></i></span>
            </el-button>
            <!-- 修改保存 -->
            <el-button type="primary" size="small" style="margin-right: 5px;width: 62px" @click="editModels()" v-if="IsEdit && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430')">
                <span v-show="!save_load">保存</span>
                <span v-show="save_load"><i class="el-icon-loading"></i></span>
            </el-button>
        </div>
        <!-- 悬浮球 -->
        <div class="bold" :style="{ right: boldRight, bottom: boldBottom }">
            <el-button type="" round size="mini" @click="openDrawer">测试规则</el-button>
        </div>
        <!-- 抽屉 -->
        <el-drawer title="测试规则" :visible.sync="drawer" size="560px">
            <el-input
                    resize="none"
                    type="textarea"
                    rows="6"
                    v-model="test_text">
            </el-input>
            <el-button type="primary" size="small" style="width: 100px!important;margin: 15px 0 15px 215px ; " round @click="toTest">
                <span v-show="!test_load">测试数据</span>
                <i class="el-icon-loading" v-show="test_load"></i>
            </el-button>
            <div v-show="test_array.length > 0" style="margin-bottom: 10px;height: 80px;line-height: 20px;overflow-y: auto;border: #e1e3e6 solid 1px;font-size: 12px;padding: 0 10px;width: auto;border-radius: 4px">
                <el-radio-group v-model="text_keyArray_checkList">
                    <el-radio label="" size="mini">无</el-radio>
                    <el-radio :label="item.id" v-for="(item, index) in text_keyArray" :key="index" size="mini">{{item.text}}</el-radio>
                </el-radio-group>
            </div>
            <div v-show="test_array.length > 0" style="width: 100%; height: calc(100% - 310px);border-radius: 4px;border: #e1e3e6 solid 1px;font-size: 14px;color: #666;float: right;overflow-y: auto;padding: 10px 20px">
                <div v-for="(item, index) in test_array" :key="index">
                    <el-tooltip class="item" effect="dark" :content="items.FF" placement="top" :manual="!(items.type)" v-for="(items, indexs) in item" :key="indexs" >
                        <span :class="testLineHeiColValid(index)"><span class="test_defult" :class="!!(higTest(items.keyArray)) ? 'test_textAct': ''" :style="testLineHeiCol({ color: items.fontc, background: items.backg })">{{items.text}}</span></span>
                    </el-tooltip>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { addModel, queryModelByid, editModel, testModel, querygetSemantic } from '@/api/qc/model'
export default {
  name: 'newModel_semanticsModule',
  data: function () {
    return {
      id: '',
      input_data: {
        role: '',
        type_data: '',
        release: false,
        userList: [],
        /*
          type_item{
            id: 随机id
            type:
                0=错误语法句
                1=单词 A
                2=或组合 A|B
                3=带有可有可无或组合 A|B?
                4=有序 A~B
                5=有序可有可无组合 A~B?
                6=可有可无组合 A? (A|B)?
                7=非组合 !A
                8=非可有可无组合 !(A?)
          }
        */
        type_item: [],
        attr_pos: '',
        attr_pos_value: 0
      },
      input: '',
      activity: [],
      edit_but: {
        text: '',
        open: false
      },
      errorItems: [],
      errorItemsActivity: [],
      allItem: [],
      save_load: false,
      IsEdit: false,
      test_text: '',
      test_load: false,
      test_array: [],
      text_keyArray: [],
      text_keyArray_checkList: '',
      col: ['#A52A2A', '#FFA500', '#DEB887', '#008B8B', '#40E0D0', '#006400', '#9932CC', '#8B0000', '#1E90FF', '#FF00FF', '#4B0082', '#66CDAA', '#800080', '#6A5ACD', '#008080', '#FF6347', '#A9A9A9'],
      upbut: [],
      downbut: [],
      // 保存最大记录数
      toConfig: 10,
      // 搜索词类
      selectItem: [],
      // 搜索词类是否加载
      selectLoad: false,
      isEditData: '',
      // 是否为实时质检
      isQcType: false,
      customerGroup: [],
      // 测试选中高亮行
      testLine: [],
      // 悬浮球位置
      boldRight: '20px',
      boldBottom: '20px',
      drawer: false
    }
  },
  methods: {
    openDrawer() {
      this.drawer = true
    },
    /**
     * 查询词类
     */
    remoteMethod(query) {
      if (query === '') {
        return
      }
      this.selectLoad = true
      querygetSemantic(query).then(response => {
        this.selectItem = response.data.data.keywords
        this.selectLoad = false
      }).catch(response => {
        this.selectLoad = false
      })
    },
    /**
     * 前进
     */
    upbutTo () {
      // eslint-disable-next-line eqeqeq
      if (this.upbut.length == 0) {
        return
      }
      var item = {}
      var array = []
      for (var i = 0; i < this.upbut.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (i == (this.upbut.length - 1)) {
          item = this.upbut[i]
        } else {
          array.push(this.upbut[i])
        }
      }
      this.upbut = array
      var json = {
        item: this.saveToListAdd(this.input_data.type_item),
        errorItem: this.saveToListAdd(this.errorItems)
      }
      this.downbut.push(json)
      // 如果大于配置
      if (this.downbut.length > this.toConfig) {
        var arrays = []
        for (var j = 1; j < this.downbut.length; j++) {
          arrays.push(this.downbut[j])
        }
        this.downbut = arrays
      }
      this.errorItems = item.errorItem
      this.errorItemsActivity = []
      this.activity = []
      this.input_data.type_item = item.item
    },
    /**
     * 撤销
     */
    downbutTo () {
      // eslint-disable-next-line eqeqeq
      if (this.downbut.length == 0) {
        return
      }
      // 拿到上一步的词
      var item = {}
      var array = []
      for (var i = 0; i < this.downbut.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (i == (this.downbut.length - 1)) {
          item = this.downbut[i]
        } else {
          array.push(this.downbut[i])
        }
      }
      this.downbut = array
      var json = {
        item: this.saveToListAdd(this.input_data.type_item),
        errorItem: this.saveToListAdd(this.errorItems)
      }
      this.upbut.push(json)
      this.errorItems = item.errorItem
      this.errorItemsActivity = []
      this.activity = []
      this.input_data.type_item = item.item
    },
    /**
     * 记录步骤
     */
    saveTo() {
      this.upbut = []
      var json = {
        item: this.saveToListAdd(this.input_data.type_item),
        errorItem: this.saveToListAdd(this.errorItems)
      }
      this.downbut.push(json)
      // 如果大于配置
      if (this.downbut.length > this.toConfig) {
        var array = []
        for (var i = 1; i < this.downbut.length; i++) {
          array.push(this.downbut[i])
        }
        this.downbut = array
      }
    },
    saveToListAdd(list) {
      var array = []
      for (var i = 0; i < list.length; i++) {
        array.push(list[i])
      }
      return array
    },
    /**
     * 清空记录步骤
     */
    clearTo() {
      this.upbut = []
      this.downbut = []
    },
    /**
     * 关闭编辑窗口
     */
    closeEdit: function () {
      // eslint-disable-next-line eqeqeq
      if (this.edit_but.text != this.isEditData) {
        this.saveTo()
      }
      this.input_data.type_item = []
      this.activity = []
      this.errorItemsActivity = []
      this.errorItems = []
      // 拿中括号中间的数据
      var data = this.edit_but.text
      var array = []
      var x = false
      var str = ''
      for (var i = 0; i < data.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (!x && data[i] == '{') {
          str = ''
          x = true
          // eslint-disable-next-line eqeqeq
        } else if (x && data[i] == '}') {
          x = false
          // eslint-disable-next-line eqeqeq
          if (str != '') {
            array.push(str)
          }
          str = ''
        } else {
          str += data[i]
        }
      }
      // 校验标签格式并添加
      for (var j = 0; j < array.length; j++) {
        if (this.versionSpan(array[j])) {
          var type = this.createSpanType(array[j])
          // eslint-disable-next-line eqeqeq
          var valid = ((type == 1) && (type != 0))
          var id = ((new Date()).getTime() + '_' + array[j]) + parseInt(Math.random() * (999999 + 1), 10)
          this.addspan(id, array[j], valid, type)
        } else {
          // eslint-disable-next-line no-redeclare
          var id = ((new Date()).getTime() + '_' + array[j]) + parseInt(Math.random() * (999999 + 1), 10)
          this.addspan(id, array[j], true, 0)
        }
      }
      this.edit_but.open = false
    },
    /**
     * 获取标签类型
     */
    createSpanType(data) {
      // eslint-disable-next-line no-useless-escape
      var containSpecial = RegExp(/[(\~)(\!)(\()(\))(\?)(\|)]+/)
      // eslint-disable-next-line no-useless-escape
      var containSpecial1 = RegExp(/[(\~)(\()(\))(\?)(\|)]+/)
      // eslint-disable-next-line no-useless-escape
      var containSpecial2 = RegExp(/[(\~)(\!)(\()(\))(\|)]+/)
      // 判断句式 A
      if (!containSpecial.test(data)) {
        return 1
        // eslint-disable-next-line brace-style
      }
      // 判断句式 !A
      // eslint-disable-next-line eqeqeq
      else if (data.length > 1 && data.substring(0, 1) == '!' && !containSpecial1.test(data)) {
        return 7
        // eslint-disable-next-line brace-style
      }
      // 判断句式 A?
      // eslint-disable-next-line eqeqeq
      else if (data.length > 1 && data.substring(data.length - 1, data.length) == '?' && !containSpecial2.test(data)) {
        return 6
        // eslint-disable-next-line brace-style
      }
      // 判断是否为单链 ()? 或 !()
      // eslint-disable-next-line eqeqeq
      else if (this.versionSpanNumber(data) == 1) {
        // 判断句式 ()?
        // eslint-disable-next-line eqeqeq
        if (data.length > 1 && data.substring(0, 1) == '(' && data.substring(data.length - 2, data.length) == ')?') {
          return 6
          // eslint-disable-next-line brace-style
        }
        // 判断句式 ()
        // eslint-disable-next-line eqeqeq
        else if (data.length > 1 && data.substring(0, 1) == '(' && data.substring(data.length - 1, data.length) == ')') {
          // eslint-disable-next-line eqeqeq
          if (data.length == 2) {
            return 0
          }
          return this.createSpanType(data.substring(1, data.length - 1))
          // eslint-disable-next-line brace-style
        }
        // 判断句式 !()
        // eslint-disable-next-line eqeqeq
        else if (data.length > 1 && data.substring(0, 2) == '!(' && data.substring(data.length - 1, data.length) == ')') {
          // eslint-disable-next-line eqeqeq
          if (data.indexOf('?') != -1) {
            return 8
          } else {
            return 7
          }
          // eslint-disable-next-line brace-style
        } else {
          return 0
        }
        // eslint-disable-next-line brace-style
      } else {
        // 拆解句式 多链
        var json = this.versionSpanCut(data)
        // eslint-disable-next-line eqeqeq
        if (json.status == 'error') {
          return 0
          // eslint-disable-next-line eqeqeq
        } else if (json.type == '|') {
          // eslint-disable-next-line eqeqeq
          if (data.indexOf('?') != -1) {
            return 3
          } else {
            return 2
          }
          // eslint-disable-next-line eqeqeq
        } else if (json.type == '~') {
          // eslint-disable-next-line eqeqeq
          if (data.indexOf('?') != -1) {
            return 5
          } else {
            return 4
          }
        } else {
          return 0
        }
      }
    },
    /**
     * 打开编辑视图
     */
    openEdit() {
      var data = ''
      for (var i = 0; i < this.input_data.type_item.length; i++) {
        data += '{' + this.input_data.type_item[i].data + '}'
      }
      this.edit_but.text = data
      this.edit_but.open = true
      this.isEditData = data
    },
    /**
     * 添加所有
     */
    addAll() {
      // eslint-disable-next-line eqeqeq
      if (this.errorItems.length != 0) {
        window.qcMessage({ type: 'warning', text: '存在错误规则' })
        return 0
        // eslint-disable-next-line eqeqeq
      } else if (this.input_data.type_item.length == 0) {
        window.qcMessage({ type: 'warning', text: '规则不能为空' })
        return 0
      } else {
        this.clearTo()
        var data = ''
        for (var i = 0; i < this.input_data.type_item.length; i++) {
          data += '{' + this.input_data.type_item[i].data + '}'
        }
        const id = (new Date()).getTime() + parseInt(Math.random() * (999999 + 1), 10)
        const json = {
          id: id,
          data: data
        }
        let isAdd = true
        const array2 = this.semanticsToArray(data)
        const that = this
        this.allItem.forEach(function (items, index) {
          // 已有模型规则分割
          const array1 = that.semanticsToArray(items.data)
          if (JSON.stringify(array2.sort()) === JSON.stringify(array1.sort())) {
            isAdd = false
            window.qcMessage({ type: 'warning', text: '已存在相同规则' })
          }
        })
        if (isAdd) {
          this.allItem.push(json)
          this.clearAll()
        }
      }
    },
    /** 规则格式化为数组 */
    semanticsToArray (data) {
      const array = []
      let x = false
      let str = ''
      for (var i = 0; i < data.length; i++) {
        if (!x && data[i] === '{') {
          str = ''
          x = true
          // eslint-disable-next-line eqeqeq
        } else if (x && data[i] == '}') {
          x = false
          // eslint-disable-next-line eqeqeq
          if (str != '') {
            array.push(str)
          }
          str = ''
        } else {
          str += data[i]
        }
      }
      return array
    },
    /**
     * 清空
     */
    clearAll() {
      this.input_data.type_item = []
      this.activity = []
      this.errorItems = []
      this.errorItemsActivity = []
    },
    clearAllbut() {
      this.clearTo()
      this.clearAll()
    },
    /**
     * 点击取消
     */
    cancel() {
      if (window.sessionStorage && window.sessionStorage.getItem('qcModelMgrQueryData')) {
        const json = JSON.parse(window.sessionStorage.getItem('qcModelMgrQueryData'))
        json.isOpen = true
        window.sessionStorage.setItem('qcModelMgrQueryData', JSON.stringify(json))
      }
      if (this.id) {
        this.$router.push('/qc/businessModeling/modelManagement')
      } else {
        this.$router.push('/qc/newModel/newModel_menu')
      }
    },
    /**
     * 增加标签(输入框回车)
     */
    add() {
      if (this.input !== '') {
        this.saveTo()
        var newid = (new Date()).getTime() + parseInt(Math.random() * (999999 + 1), 10)
        var valid = true
        this.addspan(newid, this.input, valid, 1)
        this.input = ''
      }
    },
    /**
     * 增加一个标签
     * @id: 随机id
     * @text: 值
     * @valid: true=直接填充不解析 false=解析
     */
    addspan(id, text, valid, type) {
      // eslint-disable-next-line eqeqeq
      if (type == 0) {
        this.input_data.type_item.push({
          id: id,
          data: text,
          type: 0,
          zn_data: [{
            type: 'error',
            text: '语法错误'
          }]
        })
        this.errorItems.push(id)
      } else if (valid) {
        this.input_data.type_item.push({
          id: id,
          data: text,
          type: 1,
          zn_data: [{
            type: 'text',
            text: text
          }]
        })
        return true
      } else {
        // 第一步 校验格式
        if (this.versionSpan(text)) {
          var znData = this.toZnData(text)
          this.input_data.type_item.push({
            id: id,
            data: text,
            type: type,
            zn_data: znData
          })
          return true
        } else {
          window.qcMessage({ type: 'warning', text: '数据格式不正确' })
          return false
        }
      }
    },
    /**
     * 表达式转标签显示数组
     */
    toZnData(text) {
      var str = ''
      var array = []
      for (var i = 0; i < text.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (text[i] == '!') {
          // eslint-disable-next-line eqeqeq
          if (str != '') {
            array.push({ type: 'text', text: str })
            str = ''
          }
          array.push({
            type: 'rule',
            text: ' ! '
          })
          // eslint-disable-next-line eqeqeq
        } else if (text[i] == '(') {
          // eslint-disable-next-line eqeqeq
          if (str != '') {
            array.push({ type: 'text', text: str })
            str = ''
          }
          array.push({
            type: 'sign',
            text: ' ( '
          })
          // eslint-disable-next-line eqeqeq
        } else if (text[i] == ')') {
          // eslint-disable-next-line eqeqeq
          if (str != '') {
            array.push({ type: 'text', text: str })
            str = ''
          }
          array.push({
            type: 'sign',
            text: ' ) '
          })
          // eslint-disable-next-line eqeqeq
        } else if (text[i] == '|') {
          // eslint-disable-next-line eqeqeq
          if (str != '') {
            array.push({ type: 'text', text: str })
            str = ''
          }
          array.push({
            type: 'rule',
            text: ' | '
          })
          // eslint-disable-next-line eqeqeq
        } else if (text[i] == '~') {
          // eslint-disable-next-line eqeqeq
          if (str != '') {
            array.push({ type: 'text', text: str })
            str = ''
          }
          array.push({
            type: 'rule',
            text: ' ~ '
          })
          // eslint-disable-next-line eqeqeq
        } else if (text[i] == '?') {
          // eslint-disable-next-line eqeqeq
          if (str != '') {
            array.push({ type: 'text', text: str })
            str = ''
          }
          array.push({
            type: 'rule',
            text: ' ? '
          })
        } else {
          str += text[i]
        }
      }
      // eslint-disable-next-line eqeqeq
      if (str != '') {
        array.push({ type: 'text', text: str })
      }
      return array
    },
    /**
     * 校验格式
     */
    versionSpan: function (data) {
      // eslint-disable-next-line no-useless-escape
      var containSpecial = RegExp(/[(\~)(\!)(\()(\))(\?)(\|)]+/)
      // eslint-disable-next-line no-useless-escape
      // var containSpecial1 = RegExp(/[(\~)(\()(\))(\?)(\|)]+/)
      // eslint-disable-next-line no-useless-escape
      // var containSpecial2 = RegExp(/[(\~)(\!)(\()(\))(\|)]+/)
      // 判断句式 A
      if (!containSpecial.test(data)) {
        return true
        // eslint-disable-next-line brace-style
      }
      // 判断句式 !A
      // eslint-disable-next-line eqeqeq
      else if (data.length > 1 && data.substring(0, 1) == '!' && !containSpecial.test(data.substring(1))) {
        return true
        // eslint-disable-next-line brace-style
      }
      // 判断句式 A?
      // eslint-disable-next-line eqeqeq
      else if (data.length > 1 && data.substring(data.length - 1, data.length) == '?' && !containSpecial.test(data.substring(0, data.length - 1))) {
        return true
        // eslint-disable-next-line brace-style
      }
      // 判断是否为单链 ()? 或 !()
      else {
        const itemNums = this.versionSpanNumber(data)
        // eslint-disable-next-line eqeqeq
        if (itemNums == 1) {
          // 判断句式 (非单词)?
          // eslint-disable-next-line eqeqeq
          if (data.length > 3 && data.substring(0, 1) == '(' && data.substring(data.length - 2, data.length) == ')?') {
            // (A)? ()?
            if (!containSpecial.test(data.substring(1, data.length - 2))) {
              return false
            }
            return this.versionSpan(data.substring(1, data.length - 2))
            // eslint-disable-next-line brace-style
          }
          // 判断句式 (非单词)
          // eslint-disable-next-line eqeqeq
          else if (data.length > 2 && data.substring(0, 1) == '(' && data.substring(data.length - 1, data.length) == ')') {
            if (!containSpecial.test(data.substring(1, data.length - 1))) {
              return false
            }
            return this.versionSpan(data.substring(1, data.length - 1))
            // eslint-disable-next-line brace-style
          }
          // 判断句式 !()
          // eslint-disable-next-line eqeqeq
          else if (data.length > 3 && data.substring(0, 2) == '!(' && data.substring(data.length - 1, data.length) == ')') {
            if (!containSpecial.test(data.substring(2, data.length - 1))) {
              return false
            }
            return this.versionSpan(data.substring(2, data.length - 1))
            // eslint-disable-next-line brace-style
          } else {
            return false
          }
          // eslint-disable-next-line brace-style,eqeqeq
        } else if (itemNums == 0) {
          return false
          // eslint-disable-next-line brace-style
        }
        // 如果为多链
        else {
          // 拆解句式
          var json = this.versionSpanCut(data)
          // eslint-disable-next-line eqeqeq
          if (json.status == 'error') {
            return false
          } else {
            var x = true
            var array = json.array
            for (var a = 0; a < array.length; a++) {
              var result = this.versionSpan(array[a])
              x = (x && result)
            }
            return x
          }
        }
      }
    },
    /**
     * 拆解句式
     */
    versionSpanCut(data) {
      var x = 0
      var str = ''
      var type = ''
      var array = []
      for (var i = 0; i < data.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (data[i] == '(') {
          x++
          str += data[i]
          // eslint-disable-next-line eqeqeq
        } else if (data[i] == ')') {
          x--
          str += data[i]
          // eslint-disable-next-line eqeqeq
        } else if ((data[i] == '~' || data[i] == '|') && x == 0) {
          // eslint-disable-next-line eqeqeq
          if (type == '') {
            type = data[i]
          } else {
            // eslint-disable-next-line eqeqeq
            if (type != data[i]) return { status: 'error' }
          }
          array.push(str)
          str = ''
        } else {
          str += data[i]
        }
      }
      // eslint-disable-next-line eqeqeq
      if (str != '') {
        array.push(str)
      } else {
        return { status: 'error', array: array, type: type }
      }
      return { status: 'success', array: array, type: type }
    },
    /**
     * 判断包含几个参数组
     */
    versionSpanNumber(data) {
      // eslint-disable-next-line eqeqeq
      if (data == '') {
        return 0
      }
      // 如果没有~ 和 | 运算符则为单参数组
      // eslint-disable-next-line no-useless-escape
      var containSpecial = RegExp(/[(\~)(\|)]+/)
      if (!containSpecial.test(data)) {
        return 1
      }
      var x = 0
      var number = 1
      for (var i = 0; i < data.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (data[i] == '(') {
          x++
          // eslint-disable-next-line eqeqeq
        } else if (data[i] == ')') {
          x--
          // 校验 | 和 ~ 开头的
          // eslint-disable-next-line eqeqeq
        } else if (i == 0 && (data[i] == '~' || data[i] == '|')) {
          return 0
          // 校验 | 和 ~ 结尾的
          // eslint-disable-next-line eqeqeq
        } else if (i == data.length - 1 && (data[i] == '~' || data[i] == '|')) {
          return 0
          // 校验 | 或 ~ 前后是否包含 | ~
          // eslint-disable-next-line eqeqeq
        } else if (i != 0 && (data[i] == '~' || data[i] == '|') && i != (data.length - 1) && ((data[i + 1] == '~' || data[i + 1] == '|') || (data[i - 1] == '~' || data[i - 1] == '|'))) {
          return 0
          // 校验 !
          // eslint-disable-next-line eqeqeq
        } else if ((data[i] == '~' || data[i] == '|') && x == 0) {
          number++
        }
      }
      // eslint-disable-next-line eqeqeq
      if (x != 0) {
        return 0
      }
      return number
    },
    /**
     * 是否高亮
     */
    highlight(item) {
      for (var i = 0; i < this.activity.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (this.activity[i].id == item.id) {
          return 'body_div_span body_div_span_activity'
        }
      }
      for (var k = 0; k < this.errorItemsActivity.length; k++) {
        // eslint-disable-next-line eqeqeq
        if (this.errorItemsActivity[k] == item.id) {
          return 'body_div_span_error body_div_span_activity_error'
        }
      }
      for (var j = 0; j < this.errorItems.length; j++) {
        // eslint-disable-next-line eqeqeq
        if (this.errorItems[j] == item.id) {
          return 'body_div_span_error'
        }
      }
      return 'body_div_span'
    },
    /**
     * 打印标签的颜色
     */
    span_col(id, type) {
      // 判断是否为选中
      var x = ''
      for (var i = 0; i < this.activity.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (id == this.activity[i].id) {
          x = '_activity'
        }
      }
      for (var k = 0; k < this.errorItemsActivity.length; k++) {
        // eslint-disable-next-line eqeqeq
        if (id == this.errorItemsActivity[k]) {
          x = '_activity'
        }
      }
      // eslint-disable-next-line eqeqeq
      if (type == 'text') {
        return 'body_div_span_in_text' + x
        // eslint-disable-next-line brace-style
      }
      // eslint-disable-next-line eqeqeq
      else if (type == 'rule') {
        return 'body_div_span_in_rule' + x
        // eslint-disable-next-line brace-style
      }
      // eslint-disable-next-line eqeqeq
      else if (type == 'sign') {
        return 'body_div_span_in_sign' + x
        // eslint-disable-next-line brace-style
      }
      // eslint-disable-next-line eqeqeq
      else if (type == 'error') {
        return 'body_div_span_in_error' + x
      }
    },
    /**
     * 标签 选中 或 取消选中
     * @param item 标签对象
     */
    selectSpan(item) {
      // eslint-disable-next-line eqeqeq
      if (item.type == 0) {
        var arrays = []
        for (var v = 0; v < this.errorItemsActivity.length; v++) {
          // eslint-disable-next-line eqeqeq
          if (item.id != this.errorItemsActivity[v]) {
            arrays.push(this.errorItemsActivity[v])
          }
        }
        // eslint-disable-next-line eqeqeq
        if (this.errorItemsActivity.length != arrays.length) {
          this.errorItemsActivity = arrays
        } else {
          this.errorItemsActivity.push(item.id)
        }
      } else {
        var array = []
        for (var i = 0; i < this.activity.length; i++) {
          // eslint-disable-next-line eqeqeq
          if (item.id != this.activity[i].id) {
            array.push(this.activity[i])
          }
        }
        // eslint-disable-next-line eqeqeq
        if (this.activity.length != array.length) {
          this.activity = array
        } else {
          this.activity.push({
            id: item.id,
            item: item
          })
        }
      }
    },
    /**
     * 删除表标签
     */
    delSpan(id) {
      // 移除队列
      var array = []
      for (var i = 0; i < this.input_data.type_item.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (id != this.input_data.type_item[i].id) {
          array.push(this.input_data.type_item[i])
        }
      }
      this.input_data.type_item = array
      // 移除选中
      var arrays = []
      for (var j = 0; j < this.activity.length; j++) {
        // eslint-disable-next-line eqeqeq
        if (id != this.activity[j].id) {
          arrays.push(this.activity[j])
        }
      }
      this.activity = arrays
      // 移除错误队列
      var arrays1 = []
      for (var e = 0; e < this.errorItems.length; e++) {
        // eslint-disable-next-line eqeqeq
        if (id != this.errorItems[e]) {
          arrays1.push(this.errorItems[e])
        }
      }
      this.errorItems = arrays1
      // 移除错误选中
      var arrays2 = []
      for (var v = 0; v < this.errorItemsActivity.length; v++) {
        // eslint-disable-next-line eqeqeq
        if (id != this.errorItemsActivity[v]) {
          arrays.push(this.errorItemsActivity[v])
        }
      }
      this.errorItemsActivity = arrays2
    },
    /**
     * 点击或按钮
     */
    or_but() {
      // eslint-disable-next-line eqeqeq
      if (this.activity.length > 1) {
        var id = (new Date()).getTime() + parseInt(Math.random() * (999999 + 1), 10)
        var data = ''
        // 选择词重新排列可有可无置后 并判断是否只有一个可有可无
        var array = []
        var arrayOther = []
        var all = []
        for (var j = 0; j < this.activity.length; j++) {
          // eslint-disable-next-line eqeqeq
          if (this.activity[j].item.type == 3 || this.activity[j].item.type == 5 || this.activity[j].item.type == 6 || this.activity[j].item.type == 8) {
            array.push(this.activity[j])
          } else {
            arrayOther.push(this.activity[j])
          }
          all.push(this.activity[j])
        }
        if (array.length > 1) {
          window.qcMessage({ type: 'warning', text: '只能有一个可有可无' })
          return
        } else {
          this.saveTo()
          // 先追加其他
          for (var o = 0; o < arrayOther.length; o++) {
            // eslint-disable-next-line eqeqeq
            if (o != 0) { data += '|' }
            // eslint-disable-next-line eqeqeq
            if (arrayOther[o].item.type == 4) {
              data += ('(' + arrayOther[o].item.data + ')')
            } else {
              data += arrayOther[o].item.data
            }
          }
          // 再追加可有可无
          for (var k = 0; k < array.length; k++) {
            // eslint-disable-next-line eqeqeq
            if (data != '') { data += '|' }
            // eslint-disable-next-line eqeqeq
            if (array[k].item.type == 5) {
              data += ('(' + array[k].item.data + ')')
            } else {
              data += array[k].item.data
            }
          }
        }
        var type = (array.length > 0) ? 3 : 2
        if (this.addspan(id, data, false, type)) {
          for (var d = 0; d < all.length; d++) {
            this.delSpan(all[d].id)
          }
        }
      }
    },
    /**
     * 点击可有可无按钮
     */
    notEssential() {
      // eslint-disable-next-line eqeqeq
      if (this.activity.length == 1) {
        var data = this.activity[0].item.data
        var id = (new Date()).getTime() + parseInt(Math.random() * (999999 + 1), 10)
        // eslint-disable-next-line no-useless-escape
        var containSpecial = RegExp(/[(\~)(\!)(\()(\))(\|)]+/)
        // eslint-disable-next-line no-useless-escape
        var containSpecial1 = RegExp(/\?/)
        if (containSpecial1.test(data)) {
          window.qcMessage({ type: 'warning', text: '只能有一个可有可无' })
        } else if (containSpecial.test(data)) {
          this.saveTo()
          data = ('(' + data + ')?')
          this.addspan(id, data, false, 6)
          this.delSpan(this.activity[0].id)
        } else {
          this.saveTo()
          data = data + '?'
          var status = this.addspan(id, data, false, 6)
          if (status) {
            this.delSpan(this.activity[0].id)
          }
        }
      }
    },
    /**
     * 点击非按钮
     */
    notButton() {
      // eslint-disable-next-line eqeqeq
      if (this.activity.length == 1) {
        var data = this.activity[0].item.data
        var id = (new Date()).getTime() + parseInt(Math.random() * (999999 + 1), 10)
        // eslint-disable-next-line no-useless-escape
        var containSpecial = RegExp(/[(\~)(\?)(\()(\))(\|)(\!)]+/)
        // eslint-disable-next-line no-useless-escape
        var containSpecial1 = RegExp(/\?/)
        // 查询是否为单组
        // eslint-disable-next-line eqeqeq
        if (this.versionSpanNumber(data) == 1 && data[0] == '!') {
          window.qcMessage({ type: 'warning', text: '已经为否定格式' })
        } else if (containSpecial.test(data)) {
          this.saveTo()
          data = ('!(' + data + ')')
          this.addspan(id, data, false, (containSpecial1.test(data) ? 8 : 7))
          this.delSpan(this.activity[0].id)
        } else {
          this.saveTo()
          data = '!' + data
          var status = this.addspan(id, data, false, 7)
          if (status) {
            this.delSpan(this.activity[0].id)
          }
        }
      }
    },
    /**
     * 点击有序按钮
     */
    order_but() {
      // eslint-disable-next-line eqeqeq
      if (this.activity.length > 1) {
        var id = (new Date()).getTime() + parseInt(Math.random() * (999999 + 1), 10)
        var data = ''
        // 选择词重新排列可有可无置后 并判断是否只有一个可有可无
        var array = []
        var arrayOther = []
        var all = []
        for (var j = 0; j < this.activity.length; j++) {
          // eslint-disable-next-line eqeqeq
          if (this.activity[j].item.type == 3 || this.activity[j].item.type == 5 || this.activity[j].item.type == 6 || this.activity[j].item.type == 8) {
            array.push(this.activity[j])
            arrayOther.push(this.activity[j])
          } else {
            arrayOther.push(this.activity[j])
          }
          all.push(this.activity[j])
        }
        if (array.length > 1) {
          window.qcMessage({ type: 'warning', text: '只能有一个可有可无' })
          return
        } else {
          this.saveTo()
          for (var o = 0; o < arrayOther.length; o++) {
            // eslint-disable-next-line eqeqeq
            if (o != 0) { data += '~' }
            // eslint-disable-next-line eqeqeq
            if (arrayOther[o].item.type == 2 || arrayOther[o].item.type == 3) {
              data += ('(' + arrayOther[o].item.data + ')')
            } else {
              data += arrayOther[o].item.data
            }
          }
        }
        var type = (array.length > 0) ? 5 : 4
        if (this.addspan(id, data, false, type)) {
          for (var d = 0; d < all.length; d++) {
            this.delSpan(all[d].id)
          }
        }
      }
    },
    delSpanButton() {
      // 因为数据绑定 所以定义另一个参数存id
      var array = []
      for (var i = 0; i < this.activity.length; i++) {
        array.push(this.activity[i].id)
      }
      for (var v = 0; v < this.errorItemsActivity.length; v++) {
        // eslint-disable-next-line eqeqeq
        array.push(this.errorItemsActivity[v])
      }
      if (array.length > 0) {
        this.saveTo()
      }
      for (var j = 0; j < array.length; j++) {
        this.delSpan(array[j])
      }
    },
    /**
     * 将公式转为数组
     * @param item
     * @returns {Array}
     */
    arrayAllItem(item) {
      const data = item.data
      const array = []
      var r = 0
      for (var i = 0; i < data.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (data[i] == '{') {
          r = i + 1
          // eslint-disable-next-line eqeqeq
        } else if (data[i] == '}') {
          array.push(data.substring(r, i))
        }
      }
      return array
    },
    /**
     * 删除模型规则
     * @param id
     */
    delallItem(id) {
      var array = []
      for (var i = 0; i < this.allItem.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (this.allItem[i].id != id) {
          array.push(this.allItem[i])
        }
      }
      this.allItem = array
    },
    /**
     * 删除模型规则
     * @param id
     */
    editItem(id) {
      var item = {}
      for (var i = 0; i < this.allItem.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (this.allItem[i].id === id) {
          item = this.allItem[i]
        }
      }
      // 清空所有
      this.clearAll()
      this.edit_but.text = item.data
      this.closeEdit()
      this.delallItem(id)
      this.clearTo()
    },
    /**
     * 点击保存按钮
     */
    addModels() {
      if (this.save_load) {
        return
      }
      if (this.verModelData()) {
        const data = {
          attrRole: this.input_data.role,
          flagPublish: this.input_data.release ? 1 : 0,
          groupId: window.qc_newModel.group,
          name: window.qc_newModel.name,
          ruleList: this.allItemDataArray(),
          qcType: window.qc_newModel.qcType,
          remark: window.qc_newModel.nemo,
          type: 0,
          skillGroupId: this.input_data.userList,
          attrPos: this.input_data.attr_pos,
          attrPosValue: this.input_data.attr_pos_value
        }
        addModel(data).then(response => {
          this.save_load = true
          response = response.data.data
          // eslint-disable-next-line eqeqeq
          if (response.status == 'success') {
            window.qcMessage({ type: 'success', text: '保存成功' })
            this.cancel()
          } else if (response.msg) {
            window.qcMessage({ type: 'warning', text: response.msg })
          } else {
            window.qcMessage({ type: 'error', text: '保存失败' })
          }
          this.save_load = false
        }).catch(response => {
          window.qcMessage({ type: 'error', text: '保存失败' })
          this.save_load = false
        })
      }
    },
    /**
     * 修改保存按钮
     */
    editModels() {
      if (this.save_load) {
        return
      }
      if (this.verModelData()) {
        const data = {
          id: this.id,
          attrRole: this.input_data.role,
          flagPublish: this.input_data.release ? 1 : 0,
          groupId: window.qc_newModel.group,
          name: window.qc_newModel.name,
          ruleList: this.allItemDataArray(),
          qcType: window.qc_newModel.qcType,
          remark: window.qc_newModel.nemo,
          type: 0,
          skillGroupId: this.input_data.userList,
          attrPos: this.input_data.attr_pos,
          attrPosValue: this.input_data.attr_pos_value
        }
        editModel(data).then(response => {
          this.save_load = true
          response = response.data.data
          // eslint-disable-next-line eqeqeq
          if (response.status == 'success') {
            window.qcMessage({ type: 'success', text: '保存成功' })
            this.cancel()
          } else if (response.msg) {
            window.qcMessage({ type: 'warning', text: response.msg })
          } else {
            window.qcMessage({ type: 'error', text: '保存失败' })
          }
          this.save_load = false
        }).catch(response => {
          window.qcMessage({ type: 'error', text: '保存失败' })
          this.save_load = false
        })
      }
    },
    /**
     * 校验数据完整性
     * @returns {boolean}
     */
    verModelData() {
      var f = false
      this.$emit('getFatherData')
      if (!window.qc_newModel) {
        window.qcMessage({ type: 'warning', text: '传参出错' })
        // eslint-disable-next-line eqeqeq
      } else if ((window.qc_newModel.qcType + '') == '') {
        window.qcMessage({ type: 'warning', text: '请选择质检类型' })
        // eslint-disable-next-line eqeqeq
      } else if (window.qc_newModel.group == '') {
        window.qcMessage({ type: 'warning', text: '模型分组不能为空' })
        this.$emit('inputIsNull', 'group')
        // eslint-disable-next-line eqeqeq
      } else if (window.qc_newModel.name == '') {
        window.qcMessage({ type: 'warning', text: '模型名称不能为空' })
        this.$emit('inputIsNull', 'name')
        // eslint-disable-next-line eqeqeq
      } else if (this.isQcType == false && (this.input_data.role + '') == '') {
        window.qcMessage({ type: 'warning', text: '请选择所属角色' })
      } else if (this.isQcType === true && (this.input_data.userList.length === 0 || this.input_data.userList === '')) {
        window.qcMessage({ type: 'warning', text: '请选择技能组' })
        // eslint-disable-next-line eqeqeq
      } else if (this.input_data.attr_pos === '') {
        window.qcMessage({ type: 'warning', text: '请选择模型位置' })
        // eslint-disable-next-line eqeqeq
      } else if (this.input_data.attr_pos === 1 && this.input_data.attr_pos_value === '') {
        window.qcMessage({ type: 'warning', text: '请选择模型位置的具体值' })
        // eslint-disable-next-line eqeqeq
      } else if (this.allItem.length == 0) {
        window.qcMessage({ type: 'warning', text: '请添加模型规则' })
      } else {
        f = true
      }
      return f
    },
    /**
     * 将规则列表转为数组
     */
    allItemDataArray() {
      var array = []
      for (var i = 0; i < this.allItem.length; i++) {
        array.push(this.allItem[i].data)
      }
      return array
    },
    /**
     * 测试规则
     */
    testRes: function () {
      const data = {
        ruleList: this.allItemDataArray(),
        remark: this.test_text
      }
      this.test_load = true
      testModel(data).then(response => {
        this.text_keyArray = [] // 规则
        this.test_load = false
        this.testLine = []
        var json = response.data.data.result
        // 返回结果集
        var resultList = json.result
        var hContent = json.hContent
        var array = []
        var textKeyArrayItem = []
        // 先拆分规则并排序
        for (let i = 0; i < resultList.length; i++) {
          if (resultList[i].match === false) {
            textKeyArrayItem.push([])
            continue
          }
          // 整行命中
          if (!!(resultList[i].matchSentencesNoSet) && resultList[i].matchSentencesNoSet.length > 0) {
            for (let y = 0; y < resultList[i].matchSentencesNoSet.length; y++) {
              this.testLine.push(Number(resultList[i].matchSentencesNoSet[y]))
            }
          }
          // 选择高亮颜色
          var cols = this.col[((i > this.col.length) ? (i % this.col.length) : i)]
          // 获得具体的规则
          var itemArray = this.arrayAllItem(this.allItem[i])
          var textKeyArrayIn = []
          for (var ik = 0; ik < itemArray.length; ik++) {
            if (!!(resultList[i].ruleMap['0']) && !!(resultList[i].ruleMap[ik + '']) && resultList[i].ruleMap[ik + ''] !== '') {
              var itemArrayArray = resultList[i].ruleMap[ik + ''].split(',')
              for (var ikk = 0; ikk < itemArrayArray.length; ikk++) {
                if (itemArrayArray[ikk] !== '' && resultList[i].resultIndexMap[itemArrayArray[ikk + '']]) {
                  var item = itemArray[ik]
                  var keyJson = {
                    id: (new Date()).getTime() + parseInt(Math.random() * (999999 + 1), 10),
                    text: item,
                    cols: cols
                  }
                  this.text_keyArray.push(keyJson)
                  textKeyArrayIn.push(keyJson)
                  break
                }
              }
            }
          }
          if (textKeyArrayIn.length > 0) {
            textKeyArrayItem.push(textKeyArrayIn)
          } else if (textKeyArrayIn.length === 0) {
            textKeyArrayItem.push([])
          }
        }
        // 开始逐句转换
        for (let i = 0; i < hContent.length; i++) {
          var count = 0
          var arrayIn = []
          // 第一步将整句写入
          var textJson = {
            text: hContent[i],
            type: false,
            lengths: hContent[i].length,
            number: i,
            keyArray: [],
            backg: '#fff',
            fontc: '#666'
          }
          arrayIn.push(textJson)
          // 第二步根据命中拆分
          for (var j = 0; j < resultList.length; j++) {
            if (resultList[j].match === true) {
              arrayIn = this.testResCut(arrayIn, resultList[j], count)
              if (j !== resultList.length - 1) {
                count += textKeyArrayItem[j].length
              }
            }
          }
          array.push(arrayIn)
        }
        this.test_array = array
      }).catch(response => {
        console.error(response)
        window.qcMessage({ type: 'error', text: '提交测试数据失败' })
        this.test_load = false
      })
    },
    testResCut(arrayIn, resultList, count) {
      // 第一步先解析句
      var containSpecial = RegExp(/[(\-)]+/)
      // ruleMap - key
      var cous = -1
      // eslint-disable-next-line no-unused-vars
      for (var key in resultList.ruleMap) {
        cous++
        var keyJson
        if (this.text_keyArray.length > count) {
          keyJson = this.text_keyArray[count]
        } else {
          continue
        }
        var cols = this.text_keyArray[count].cols
        // ruleMap用逗号分割
        var keyArrays = resultList.ruleMap[cous + ''].split(',')
        // 是否命中规则
        var mz = true
        for (var ka = 0; ka < keyArrays.length; ka++) {
          // eslint-disable-next-line eqeqeq
          if (keyArrays[ka] == '' || !resultList.resultIndexMap[keyArrays[ka]]) {
            continue
          }
          // eslint-disable-next-line eqeqeq
          if (mz == true) {
            count++
            mz = false
          }
          var resultIndexMapKey = resultList.resultIndexMap[keyArrays[ka]]
          for (var Indexkey in resultIndexMapKey) {
            var number = Number(Indexkey)
            // 如果行数相同
            // eslint-disable-next-line eqeqeq
            if (number == arrayIn[0].number) {
              this.testLine.push(number) // 全行高亮
              var IndexValue = resultIndexMapKey[Indexkey]
              // 逗号分隔位置
              var arrayIndexValue = IndexValue.split(',')
              for (var k = 0; k < arrayIndexValue.length; k++) {
                // 判断句式
                if (containSpecial.test(arrayIndexValue[k])) {
                  // 有 - 的句式
                  var start = Number(arrayIndexValue[k].substring(0, arrayIndexValue[k].indexOf('-'))) // 开始节点
                  var end = Number(arrayIndexValue[k].substring(arrayIndexValue[k].indexOf('-') + 1)) // 结束节点
                  var nowCode = 0
                  var nextarrayIn = []
                  for (var m = 0; m < arrayIn.length; m++) {
                    // 选中节点

                    // eslint-disable-next-line eqeqeq,no-mixed-operators
                    if (!(nowCode >= end || (nowCode + arrayIn[m].lengths) <= start) && arrayIn[m].type == false) {
                      // eslint-disable-next-line eqeqeq
                      // eslint-disable-next-line eqeqeq
                      if (start <= nowCode) {
                        // eslint-disable-next-line eqeqeq
                        if (end >= (nowCode + arrayIn[m].lengths)) {
                          var toJsons = {
                            text: arrayIn[m].text,
                            type: true,
                            lengths: arrayIn[m].text.length,
                            number: arrayIn[m].number,
                            FF: arrayIn[m].FF + '\n' + '命中：' + keyJson.text + '(选中：' + arrayIn[m].number + '#' + arrayIndexValue[k] + ')',
                            keyArray: [],
                            backg: cols,
                            fontc: '#fff'
                          }
                          toJsons.keyArray = this.pushNew(toJsons.keyArray, keyJson.id)
                          nextarrayIn.push(toJsons)
                        } else {
                          var sJsons = {
                            text: arrayIn[m].text.substring(0, (end - nowCode)),
                            type: true,
                            lengths: arrayIn[m].text.substring(0, (end - nowCode)).length,
                            number: arrayIn[m].number,
                            FF: '命中：' + keyJson.text + '(选中：' + arrayIn[m].number + '#' + arrayIndexValue[k] + ')',
                            keyArray: [],
                            backg: cols,
                            fontc: '#fff'
                          }
                          sJsons.keyArray = this.pushNew(sJsons.keyArray, keyJson.id)
                          nextarrayIn.push(sJsons)
                          var eJson = {
                            text: arrayIn[m].text.substring((end - nowCode), arrayIn[m].text.lengths),
                            type: false,
                            lengths: arrayIn[m].text.substring((end - nowCode), arrayIn[m].text.lengths).length,
                            number: arrayIn[m].number,
                            keyArray: [],
                            backg: '#fff',
                            fontc: '#666'
                          }
                          nextarrayIn.push(eJson)
                        }
                      } else {
                        // 开头一段
                        var ssJson = {
                          text: arrayIn[m].text.substring(0, start - nowCode),
                          type: false,
                          lengths: arrayIn[m].text.substring(0, start - nowCode).length,
                          number: arrayIn[m].number,
                          keyArray: [],
                          backg: '#fff',
                          fontc: '#666'
                        }
                        nextarrayIn.push(ssJson)
                        // eslint-disable-next-line eqeqeq
                        if (end >= (nowCode + arrayIn[m].lengths)) {
                          var itArray = []
                          itArray.push(keyJson.id)
                          var sssJson = {
                            text: arrayIn[m].text.substring(start - nowCode),
                            type: true,
                            lengths: arrayIn[m].text.substring(start - nowCode).length,
                            number: arrayIn[m].number,
                            FF: '命中：' + keyJson.text + '(选中：' + arrayIn[m].number + '#' + arrayIndexValue[k] + ')',
                            keyArray: itArray,
                            backg: cols,
                            fontc: '#fff'
                          }
                          nextarrayIn.push(sssJson)
                        } else {
                          var itArrays = []
                          itArrays.push(keyJson.id)
                          var ssssJson = {
                            text: arrayIn[m].text.substring((start - nowCode), (end - nowCode)),
                            type: true,
                            lengths: arrayIn[m].text.substring((start - nowCode), (end - nowCode)).length,
                            number: arrayIn[m].number,
                            FF: '命中：' + keyJson.text + '(选中：' + arrayIn[m].number + '#' + arrayIndexValue[k] + ')',
                            keyArray: itArrays,
                            backg: cols,
                            fontc: '#fff'
                          }
                          nextarrayIn.push(ssssJson)
                          var eeeeJson = {
                            text: arrayIn[m].text.substring((end - nowCode), arrayIn[m].text.lengths),
                            type: false,
                            lengths: arrayIn[m].text.substring((end - nowCode), arrayIn[m].text.lengths).length,
                            number: arrayIn[m].number,
                            keyArray: [],
                            backg: '#fff',
                            fontc: '#666'
                          }
                          nextarrayIn.push(eeeeJson)
                        }
                      }
                      nowCode += arrayIn[m].lengths
                      // eslint-disable-next-line eqeqeq
                    } else if (!(nowCode >= end || (nowCode + arrayIn[m].lengths) <= start) && arrayIn[m].type == true) {
                      // eslint-disable-next-line eqeqeq
                      if (start <= nowCode) {
                        // eslint-disable-next-line eqeqeq
                        if (end >= (nowCode + arrayIn[m].lengths)) {
                          var zxsssJson = {
                            text: arrayIn[m].text,
                            type: true,
                            lengths: arrayIn[m].text.length,
                            number: arrayIn[m].number,
                            FF: arrayIn[m].FF + '\n' + '命中：' + keyJson.text + '(选中：' + arrayIn[m].number + '#' + arrayIndexValue[k] + ')',
                            keyArray: arrayIn[m].keyArray,
                            backg: '#F56C6C',
                            fontc: '#fff'
                          }
                          zxsssJson.keyArray = this.pushNew(zxsssJson.keyArray, keyJson.id)
                          nextarrayIn.push(zxsssJson)
                        } else {
                          var zsJson = {
                            text: arrayIn[m].text.substring(0, (end - nowCode)),
                            type: true,
                            lengths: arrayIn[m].text.substring(0, (end - nowCode)).length,
                            number: arrayIn[m].number,
                            FF: arrayIn[m].FF + '\n' + '命中：' + keyJson.text + '(选中：' + arrayIn[m].number + '#' + arrayIndexValue[k] + ')',
                            keyArray: arrayIn[m].keyArray,
                            backg: '#F56C6C',
                            fontc: '#fff'
                          }
                          zsJson.keyArray = this.pushNew(zsJson.keyArray, keyJson.id)
                          nextarrayIn.push(zsJson)
                          var zeJson = {
                            text: arrayIn[m].text.substring((end - nowCode), arrayIn[m].text.lengths),
                            type: true,
                            lengths: arrayIn[m].text.substring((end - nowCode), arrayIn[m].text.lengths).length,
                            number: arrayIn[m].number,
                            FF: arrayIn[m].FF,
                            keyArray: arrayIn[m].keyArray,
                            backg: arrayIn[m].backg,
                            fontc: '#fff'
                          }
                          nextarrayIn.push(zeJson)
                        }
                      } else {
                        // 开头一段
                        var zssJson = {
                          text: arrayIn[m].text.substring(0, start - nowCode),
                          type: true,
                          lengths: arrayIn[m].text.substring(0, start - nowCode).length,
                          number: arrayIn[m].number,
                          FF: arrayIn[m].FF,
                          keyArray: arrayIn[m].keyArray,
                          backg: arrayIn[m].backg,
                          fontc: '#fff'
                        }
                        nextarrayIn.push(zssJson)
                        // eslint-disable-next-line eqeqeq
                        if ((nowCode + arrayIn[m].lengths) <= end) {
                          var zsssJson = {
                            text: arrayIn[m].text.substring(start - nowCode),
                            type: true,
                            lengths: arrayIn[m].text.substring(start - nowCode).length,
                            number: arrayIn[m].number,
                            FF: arrayIn[m].FF + '\n' + '命中：' + keyJson.text + '(选中：' + arrayIn[m].number + '#' + arrayIndexValue[k] + ')',
                            keyArray: arrayIn[m].keyArray,
                            backg: '#F56C6C',
                            fontc: '#fff'
                          }
                          zsssJson.keyArray = this.pushNew(zsssJson.keyArray, keyJson.id)
                          nextarrayIn.push(zsssJson)
                        } else {
                          var zssssJson = {
                            text: arrayIn[m].text.substring((start - nowCode), (end - nowCode)),
                            type: true,
                            lengths: arrayIn[m].text.substring((start - nowCode), (end - nowCode)).length,
                            number: arrayIn[m].number,
                            FF: arrayIn[m].FF + '\n' + '命中：' + keyJson.text + '(选中：' + arrayIn[m].number + '#' + arrayIndexValue[k] + ')',
                            keyArray: arrayIn[m].keyArray,
                            backg: '#F56C6C',
                            fontc: '#fff'
                          }
                          zssssJson.keyArray = this.pushNew(zssssJson.keyArray, keyJson.id)
                          nextarrayIn.push(zssssJson)
                          var zeeeeJson = {
                            text: arrayIn[m].text.substring((end - nowCode), arrayIn[m].text.lengths),
                            type: true,
                            lengths: arrayIn[m].text.substring((end - nowCode), arrayIn[m].text.lengths).length,
                            number: arrayIn[m].number,
                            FF: arrayIn[m].FF,
                            keyArray: arrayIn[m].keyArray,
                            backg: arrayIn[m].backg,
                            fontc: '#fff'
                          }
                          nextarrayIn.push(zeeeeJson)
                        }
                      }
                      nowCode += arrayIn[m].lengths
                    } else {
                      nextarrayIn.push(arrayIn[m])
                      nowCode += arrayIn[m].lengths
                    }
                  }
                  arrayIn = nextarrayIn
                }
              }
            }
          }
        }
      }
      return arrayIn
    },
    /**
     * 测试
     */
    toTest() {
      if (!this.test_load) {
        // eslint-disable-next-line eqeqeq
        if (this.test_text == '') {
          window.qcMessage({ type: 'warning', text: '请输入测试数据' })
          // eslint-disable-next-line eqeqeq
        } else if (this.allItem.length == 0) {
          window.qcMessage({ type: 'warning', text: '请添加模型规则' })
        } else {
          this.testRes()
        }
      }
    },
    higTest (list) {
      for (var i = 0; i < list.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (list[i] == this.text_keyArray_checkList) {
          return true
        }
      }
      return false
    },
    pushNew(list, obj) {
      var result = []
      for (var i = 0; i < list.length; i++) {
        result.push(list[i])
      }
      result.push(obj)
      return result
    },
    testLineHeiCol ({ color, background }) {
      if (background === '#fff') {
        return { color }
      } else {
        return { color, background }
      }
    },
    testLineHeiColValid (index) {
      for (var i = 0; i < this.testLine.length; i++) {
        if (index === this.testLine[i]) {
          return 'test_defult_activity_line'
        }
      }
      return ''
    }
  },
  mounted() {
    if (this.$router.currentRoute.query && this.$router.currentRoute.query.id) {
      this.id = this.$router.currentRoute.query.id
      queryModelByid(this.id).then(response => {
        const that = this
        const modelSkillGroups = []
        if (response.data.data.modelRelation) {
          this.input_data.userList = []
          response.data.data.modelRelation.forEach(function (relationItem, index) {
            modelSkillGroups.push(relationItem.skillGroupId)
          })
        }
        response = response.data.data.qcModel
        const json = {
          group: response.groupId,
          name: response.name,
          nemo: response.remark,
          qcType: response.qcType
        }
        this.$emit('setFatherData', json)
        // 验证是否为实时质检
        this.$emit('getFatherData')
        // eslint-disable-next-line eqeqeq
        if (window.qc_newModel.qcType == '1') {
          this.isQcType = true
        }
        if (this.isQcType === true) {
          // 取客服组
          this.$qcAuthUtis.qcSkillGroupList('aicc-qc', '101100', function(response) {
            that.customerGroup = []
            response = response.data.data
            for (let i = 0; i < response.length; i++) {
              const json = {
                text: response[i].name,
                value: response[i].id
              }
              that.customerGroup.push(json)
              modelSkillGroups.forEach(function (skillItem) {
                if (json.value === skillItem) {
                  that.input_data.userList.push(skillItem)
                }
              })
            }
          })
        }
        this.input_data.role = response.attrRole
        this.input_data.attr_pos = response.attrPos
        this.input_data.attr_pos_value = Number(response.attrPosValue)
        // eslint-disable-next-line eqeqeq
        this.input_data.release = !!(response.flagPublish == 1)
        this.allItem = []
        for (let i = 0; i < response.ruleList.length; i++) {
          const id = (new Date()).getTime() + parseInt(Math.random() * (999999 + 1), 10)
          this.allItem.push({ id: id, data: response.ruleList[i] })
        }
      }).catch(response => {
      })
      this.IsEdit = true
    } else {
      // 验证是否为实时质检
      this.$emit('getFatherData')
      // eslint-disable-next-line eqeqeq
      if (window.qc_newModel.qcType == '1') {
        this.isQcType = true
      }
      if (this.isQcType === true) {
        // 取客服组
        const that = this
        this.$qcAuthUtis.qcSkillGroupList('aicc-qc', '101100', function(response) {
          that.customerGroup = []
          response = response.data.data
          for (var i = 0; i < response.length; i++) {
            var json = {
              text: response[i].name,
              value: response[i].id
            }
            that.customerGroup.push(json)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
    .max_box{
        width: 100%;
        display: inline-block;
        padding: 0px 0 0 0;
        font-size: 14px;
    }
    .div_tab{
        width: 100%;
        color: #333333;
        margin-top: 20px;
        border-bottom: #e1e3e6 solid 1px;
        padding-bottom: 10px;
    }
    .div_title_span {
        border-left: #357cfd solid 3px;
        line-height: 6px;
        height: 12px;
        padding-left: 10px;
        line-height: 10px;
        font-size: 15px;
        color: #666;
    }
    .div_title_span_i{
        color: #fab153;
        margin-left: 10px;
        cursor: help;
    }
    .div_box{
        width: 100%;
        padding: 15px 0 25px 0;
        display: inline-block;
        margin-top: 10px;
    }
    .div_input{
        width: 200px;
    }
    .div_span{
        margin-right:10px;
        font-size: 14px;
        color: #333;
    }
    .div_main_header{
        width: auto;
        min-height: 35px;
        border-radius: 4px 4px 0 0;
        border-top: #e1e3e6 solid 1px;
        border-left: #e1e3e6 solid 1px;
        border-right: #e1e3e6 solid 1px;
        font-size: 14px;
        padding: 5px 14px 5px 14px;
    }
    .div_main_body{
        width: auto;
        height: 105px;
        border-radius: 0 0 4px 4px;
        border: #e1e3e6 solid 1px;
        padding: 5px 14px;
        font-size: 14px;
        color: #666;
        overflow-y: auto;
    }
    .div_main_body_edit{
        width: auto;
        height: 115px;
        border-radius: 0 0 4px 4px;
        border: #e1e3e6 solid 1px;
        font-size: 14px;
        color: #666;
    }
    .div_main_header_button{
        padding: 5px 0;
        min-width: 60px;
        margin: 5px 5px 0 5px;
    }
    .div_main_foot{
        padding: 10px 0 0 0;
    }
    .end_box{
        width: auto;
        height: 200px;
        margin-bottom: 20px;
        overflow-x: hidden;
        overflow-y: auto;
        border-radius:4px;
        border: #e1e3e6 solid 1px;
        padding: 10px 10px;
    }
    .end_box_item{
        width: auto;
        height: 30px;
        margin-bottom: 5px;
        line-height: 30px;
        padding: 0 0px 0 10px;
        font-size: 14px;
    }
    .end_box_xu{
        float: left;
        margin-top: 2.5px;
        width: 25px;
        height: 25px;
        background: #f1f1f1;
        border-radius: 15px;
        color: #777;
        text-align: center;
        line-height: 25px;
        font-size: 12px;
        font-weight: bolder;
        border: #ddd solid 1px;
    }
    .end_box_text{
        width:calc(100% - 120px) ;
        float: left;
        padding-left: 10px;
    }
    .end_box_text_div{
        float: left;
        height: 25px;
        margin-right: 8px;
        margin-bottom: 8px;
    }
    .end_box_text_span{
        padding: 3px 10px 5px 10px;
        border-radius: 4px;
        border: #bedeff solid 1px;
        color: #777;
        background: #f1fbfe;
    }
    .end_box_remove{
        float: left;
        height: 30px;
        width: 30px;
        line-height: 30px;
        font-size: 20px;
        margin-left: 5px;
        cursor: pointer;
    }
    .end_box_remove:hover{
        color:#F56C6C;
    }
    .end_box_edit{
        float: left;
        height: 30px;
        width: 30px;
        line-height: 30px;
        font-size: 20px;
        margin-left: 5px;
        cursor: pointer;
    }
    .end_box_edit:hover{
        color:#409EFF;
    }
    .body_div_span{
        background: #f1f1f1;
        width:auto;
        display:inline;
        float: left;
        height: 25px;
        line-height: 25px;
        padding: 0 8px;
        margin: 5px;
        font-size: 14px;
        border-radius: 4px;
        cursor:pointer;
        border: #ddd solid 1px;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
    }
    .body_div_span:hover{
        border: #409EFF solid 1px;
    }
    .body_div_span_error{
        background: #f1f1f1;
        width:auto;
        display:inline;
        float: left;
        height: 25px;
        line-height: 25px;
        padding: 0 8px;
        margin: 5px;
        font-size: 14px;
        border-radius: 4px;
        cursor:pointer;
        border: #f1f1f1 solid 1px;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
    }
    .body_div_span_error:hover{
        border: #F56C6C solid 1px;
    }
    .body_div_span_activity{
        border: #409EFF solid 1px !important;
        background: #409EFF!important;
        color: #f1f1f1;
    }
    .body_div_span_activity_error{
        border: #F56C6C solid 1px !important;
        background: #F56C6C!important;
        color: #f1f1f1;
    }
    .body_div_span_in_text{
        color: #777;
    }
    .body_div_span_in_rule{
        color: #F56C6C;
        font-weight: bolder;
    }
    .body_div_span_in_sign{
        color: #67C23A;
        font-weight: bolder;
    }
    .body_div_span_in_error{
        color: #F56C6C;
        font-weight: bolder;
    }
    .body_div_span_in_text_activity{
        color: #eee;
    }
    .body_div_span_in_rule_activity{
        color: #fff;
        font-weight: bolder;
    }
    .body_div_span_in_sign_activity{
        color: #eee;
        font-weight: bolder;
    }
    .body_div_span_in_error_activity{
        color: #fff;
        font-weight: bolder;
    }
    .div_main_header_button_right{
        padding: 5px 5px;
        margin: 5px 5px 0 5px;
        float: right;
    }
    .test_textAct{
        cursor:pointer;
        padding: 0 0px;
        font-size: 18px;
        font-weight: bolder;
        color: #fff !important;
        background: #000 !important;
        padding: 0 4px;
    }
    .test_defult {
        line-height: 25px;
        letter-spacing:2px;
        color: #999;
        padding: 0 2px;
    }
    .test_defult_activity_line{
        background: #fef0f0;
    }
    .bold{
        width: 80px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #666;
        position: fixed;
        font-size: 12px;
        color: #337eff;
    }
    .el-drawer__wrapper >>> .el-drawer__header > span{
        font-size: 16px;
        border-left: #337eff solid 3px;
        line-height: 14px;
        padding-left: 10px;
    }
    .el-drawer__wrapper >>> .el-drawer__header{
        border-bottom: #e1e3e6 solid 1px;
        padding: 0px 0 10px 0;
        margin-bottom: 15px;
    }
    .el-drawer__wrapper >>> .el-drawer{
        padding: 20px;
    }
    .el-drawer__wrapper >>> .el-drawer__header > span:focus{
        outline:0px solid;
    }
    .el-popover-qc {
        background: #ee9900!important;
    }
    .el-popover-qc .popper__arrow{
        background: #ee9900!important;
    }
    .div_main_body_edit >>> textarea {
        resize: none!important;
    }
</style>
